import React, { useCallback, useMemo } from 'react'
import {
	PivotViewComponent, FieldList, Inject,
	PivotChart,
	DrillThrough,
	// CalculatedField,
	Toolbar,
	PDFExport,
	ExcelExport,
	// ConditionalFormatting,
	// NumberFormatting
} from '@syncfusion/ej2-react-pivotview'
import { useInstData } from 'tyan/public/hooks'

const toolbarOptions = [
	// 'New', 'Save', 'SaveAs', 'Rename', 'Remove', 'Load',
	'Grid', 'Chart', 'FieldList', 'Export',
	// 'SubTotal', 'GrandTotal', 'ConditionalFormatting', 'NumberFormatting'
]

const PivotView = props => {
	const { me } = useInstData(props)
	const { data, onClose, settings, otherSettings } = props

	const dataSourceSettings = useMemo(() => ({
		dataSource: data,
		expandAll: false,
		filters: [],
		...settings
	}), [])

	const toolbarRender = useCallback(args => {
		const { customToolbar } = args
		const fieldListIndex = customToolbar.findIndex(o => o.id && o.id.includes('fieldlist'))
		if (fieldListIndex >= 0) {
			customToolbar.unshift(...(customToolbar.splice(fieldListIndex, 1)))
			delete customToolbar[0].align
		}

		customToolbar.push({
			// id: "_close",
			align: 'Right',
			prefixIcon: "e-close e-icons",
			click: onClose,
			tooltipText: "关闭",
		})
	}, [])

	return <PivotViewComponent
		// id='PivotView'
		ref={d => d && d !== me.pivot && (/* window.pivot =  */me.pivot = d)}
		width={'100%'} height={'100%'}
		dataSourceSettings={dataSourceSettings}
		showFieldList={true}
		// gridSettings={{ columnWidth: 140 }}
		allowExcelExport={true}
		allowDrillThrough={true}
		// allowConditionalFormatting={true}
		// allowNumberFormatting={true}
		// allowPdfExport={true}
		showToolbar={true}
		// allowCalculatedField={true}
		displayOption={{ view: 'Both' }}
		toolbar={toolbarOptions}
		toolbarRender={toolbarRender}
		{...otherSettings}
	>
		<Inject services={[FieldList, Toolbar, PDFExport, ExcelExport, PivotChart, DrillThrough,/* CalculatedField, ConditionalFormatting, NumberFormatting */]} />
	</PivotViewComponent>
}

export default PivotView